export const ROUTE_DASHBOARD = '/dashboard'
export const ROUTE_WELCOME = '/welcome'
export const ROUTE_LOGIN = '/login'
export const ROUTE_REGISTRATION = '/registration'
export const ROUTE_INVOICES = '/invoices/list'
export const ROUTE_INVOICES_APPLICATIONS = '/invoices/applications'
export const ROUTE_INVOICES_APPLICATIONS_CREATE = '/invoices/applications/create'
export const ROUTE_INVOICES_APPLICATIONS_SUCCESS = '/invoices/applications/success'
export const ROUTE_SUPPLIER = '/supplier'
export const ROUTE_ANTICIPATIONS = '/anticipations'
export const ROUTE_LOGOUT = '/logout'
export const ROUTE_ANTICIPATION_REVIEW = '/anticipation-review'
export const ROUTE_ANTICIPATION_SUCCESS = '/anticipation-success'
export const ROUTE_REFERRAL_LANDING = '/referral'
export const ROUTE_REFERRAL_ACHIEVEMENTS = '/referral/achievements'
